import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'

export const FacilitiesTitles = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img className='' alt='titles' src={`${process.env.PUBLIC_URL}/images/system/system-titles.webp`} />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                    <span className='text-pborange'>Titles</span> are transferable labels that affect a unit’s status. Each <span className='text-pborange'>unit</span> or <span className='text-pborange'>item</span> possesses a Title from the beginning, and each Title has different effects. You can equip Titles however you desire, so if you obtain an item with a powerful Title, be sure to try <span className='text-pborange'>transferring</span> it to something else!
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'titles',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Affix powerful Titles for various, powerful stat boosts!
'
                    />{' '}
                    <p>
                        Titles can also be equipped to <span className='text-pborange'>dungeons</span> you’ve created. Affix a Title to a dungeon and every floor of the dungeon you clear will <span className='text-pborange'>increase that Title’s stats!</span> Defeat random dungeons to strengthen Titles and use them to improve your units and items!
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'titles',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="When you give a dungeon a Title, all monsters in that dungeon will also receive that Title. Be sure you’re ready for some difficult battles before you decide to equip a powerful Title!"
                    />{' '}
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </>
    )
}
